<script setup lang="ts">
import { useApiGetOrderBuyerDetail } from '~/apiClient';
import { ROUTE_NAMES } from '~/constants/routes';

// PROPS
interface Props {
    orderId: string;
}

const { orderId } = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();
const localePath = useLocalePath();
const { data } = useApiGetOrderBuyerDetail(computed(() => orderId));

// DATA
const order = computed(() => data.value?.order);
const { canEdit } = useOrderStatus(() => order.value);
</script>

<template>
    <div class="flex flex-col justify-center gap-y-4 bg-white p-4 md:flex-1 lg:flex-none lg:p-6">
        <UButton
            :label="tt('account.orders.edit')"
            :disabled="!canEdit"
            block
            size="lg"
            :ui="buttonResponsiveSizeUi('lg', 'xl')"
            :to="localePath({ name: ROUTE_NAMES.ACCOUNT_ORDER_EDIT, params: { id: orderId } })"
        />
        <UButton
            :label="tt('account.orders.action')"
            color="neutral"
            variant="outline"
            block
            size="lg"
            :ui="buttonResponsiveSizeUi('lg', 'xl')"
            :to="localePath({ name: ROUTE_NAMES.ACCOUNT_ORDER, params: { id: orderId } })"
        />
    </div>
</template>
